export class Funcionalidade {
  codigoFuncionalidade: number;
  codigoFuncionalidadePai: number;
  codigoSistema: number;
  nome: string;
  descricao: string;
}

